import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { ProductDiscountMgInfoType } from '@kinderlabs-pos/shared-data-type';

export const createProductDiscountInfoAsync =
	(rootUrl: string) => async (props: Omit<ProductDiscountMgInfoType, 'id'>) =>
		(await posAxiosClient.post<ProductDiscountMgInfoType>(`${rootUrl}/product-discount`, props))
			.data;
